var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgUrls && _vm.imgUrls.length > 0)?_c('div',{ref:"imgDiv",class:_vm.imgClass,attrs:{"id":"imgDiv"},on:{"mousewheel":_vm.handleScroll}},[_c('img',{attrs:{"src":_vm.getFullUrl(this.imgUrls[_vm.nowIndex])}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }